import { useStaticQuery, graphql } from 'gatsby';

export const useLocalizedEvents = selectedLocale => {
  const {
    allPrismicEventList: { edges: eventLists },
    allPrismicEvent: { edges: events },
  } = useStaticQuery(graphql`
    query {
      allPrismicEventList {
        edges {
          node {
            lang
            data {
              no_events {
                text
              }
              title {
                text
              }
            }
          }
        }
      }

      allPrismicEvent(sort: { order: ASC, fields: data___date }) {
        edges {
          node {
            uid
            lang
            data {
              date(formatString: "DD,MMM")
              short_description {
                text
              }
              title {
                text
              }
              read_more_text {
                text
              }
              image {
                alt
                localFile {
                  childImageSharp {
                    fluid(maxWidth: 400) {
                      ...GatsbyImageSharpFluid
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  `);

  return {
    list: eventLists.filter(({ node }) => node.lang === selectedLocale),
    events: events.filter(({ node }) => node.lang === selectedLocale),
  };
};
